import type { IntimacaoSentencaDados, PrazoEsclarecimento } from '../types/encerramento.types';

const PRAZO: PrazoEsclarecimento = {
  iniciadoEm: '2026-08-17T12:00:00.000Z',
  vencimentoEm: '2026-08-25T23:00:00.000Z',
  diasUteis: 5,
  diasRestantes: 5,
  calendarioFeriadosAusente: false,
};

export const MOCK_INTIMACAO_SENTENCA: IntimacaoSentencaDados = {
  numeroProcesso: 'ARB-2026-004871',
  camara: 'Câmara Arbitralis',
  emitidoEm: '2026-08-17T12:12:00.000Z',
  sentencaProferidaEm: '2026-08-17T11:40:00.000Z',
  intimados: [
    { parteId: 'p1', nome: 'Construtora Almeida Ltda.', papel: 'requerente' },
    { parteId: 'p2', nome: 'Marcos Ferreira de Souza', papel: 'requerido' },
  ],
  prazo: PRAZO,
  codigoAutenticidade: '7K4P-92QD-11XZ',
  processoEncerradoEm: null,
};
